export interface ChatMessageAction {
  text: string
  callback (this: ChatMessage, action: this): void
}

export interface ChatMessageAttributes extends Object {
  userJoined: boolean
}

export default class ChatMessage {
  system: boolean
  id = String(Math.random())
  sent = false
  disabled = false
  actions: ChatMessageAction[] = []
  contentUrl: Promise<string> | false
  attributes: ChatMessageAttributes
  filename: string
  isImage: boolean

  constructor (data: any) {
    Object.assign(this, data)
    this.system = data.author === 'Kintell' || !data.author
  }
}
